// frontend/src/components/capacitor/CapacitorSuccess.tsx
import { Capacitor } from '@capacitor/core'
import { Share } from '@capacitor/share'
import './Capacitor.css'

interface Props {
  renderJobId: string
  onNewExport: () => void
}

// Im nativen WebView ist window.location.origin "https://localhost" —
// Download/Share müssen auf die echte API zeigen.
const API_BASE = Capacitor.isNativePlatform() ? 'https://chatarchiv.de' : ''

export function CapacitorSuccess({ renderJobId, onNewExport }: Props) {
  const downloadUrl = `${API_BASE || window.location.origin}/api/upload/download/${renderJobId}`

  const handleDownload = () => {
    window.open(downloadUrl, '_blank')
  }

  const handleShare = async () => {
    try {
      await Share.share({
        title: 'WhatsApp Chat Export',
        url: downloadUrl,
        dialogTitle: 'PDF teilen',
      })
    } catch {
      // User cancelled share or share not available — silently ignore
    }
  }

  return (
    <div className="cap-success">
      <div className="cap-success-check">✅</div>
      <h2 className="cap-success-title">PDF erstellt!</h2>

      <button type="button" className="cap-success-download-btn" onClick={handleDownload}>
        ⬇ PDF herunterladen
      </button>

      <button type="button" className="cap-success-share-btn" onClick={handleShare}>
        ↗ PDF teilen
      </button>

      <button type="button" className="cap-success-new-btn" onClick={onNewExport}>
        Neuen Chat exportieren
      </button>
    </div>
  )
}
